import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";

import { DataGridComponent } from "./PaginationComponent";
const MyTrips = () => {
  const userDetails = useSelector((state) => state?.userDetails);
  const userMyTrips = userDetails?.my_events;
  const myOrganised = userDetails?.my_organized_trips;
  const getTripStatus = (eventDetails) => {
    const checkIsEventEnd = () => {
      const tripEndDate = eventDetails?.end_date;
      const tripEndTime = eventDetails?.end_time;
      const eventTimeZone = eventDetails?.time_zone;
      let convertedTimeZone = eventTimeZone;

      if (eventTimeZone === "IST") {
        convertedTimeZone = "Asia/Kolkata";
      }
      const eventEndStatus = moment.tz(
        tripEndDate + " " + tripEndTime,
        "YYYY-MM-DD HH:mm",
        convertedTimeZone
      );

      const currentDateAndTime = moment.tz(convertedTimeZone);
      if (eventDetails?.event_status === 'cancelled') {
        return false
      } else {
        return currentDateAndTime.isAfter(eventEndStatus);
      }
    };

    const eventTimeZone = eventDetails?.time_zone;
    let convertedTimeZone = eventTimeZone;

    if (eventTimeZone === "IST") {
      convertedTimeZone = "Asia/Kolkata";
    }
    const isEventStarted = moment.tz(
      eventDetails?.start_date + " " + eventDetails?.start_time,
      "YYYY-MM-DD HH:mm",
      convertedTimeZone
    );

    const currentDate = moment.tz(convertedTimeZone);

    const isTripIsOnGoing = () => {
      if (eventDetails?.event_status === 'cancelled') {
        return false
      } else {
        if (currentDate.isBefore(isEventStarted)) {
          return false;
        } else {
          return true;
        }
      }
    };

    const isCancelledTrip = () => {
      if (eventDetails.event_status === "cancelled") {
        return true
      }
      else {
        return false
      }
    }
    const isEventEnd = checkIsEventEnd();
    const isTripStarted = isTripIsOnGoing();
    const isCancelled = isCancelledTrip()

    if (isEventEnd) {
      return "Finished";
    } else if (isTripStarted) {
      return "Ongoing";
    } else if (isCancelled) {
      return "Cancelled"
    } else {
      return "Upcoming";
    }
  };


  const columns = [
    {
      field: "ID_event",
      headerName: "Event ID",
      width: 180,
      renderCell: (params) => (
        <Link
          to={`/event-management/event/${params.value}`}
          style={{ color: "blue" }}
        >
          {params.value}
        </Link>
      ),
      cellClassName: "eventid-cell",
      headerClassName: "custom-header",
    },
    {
      field: "start_date",
      headerName: "Trip date",
      width: 180,
      cellClassName: "fullname-cell",
      headerClassName: "custom-header",
    },
    {
      field: "event_status",
      headerName: "Trip status",
      width: 180,
      cellClassName: "fullname-cell",
      headerClassName: "custom-header",
    },
    {
      field: "trip_title",
      headerName: "Trip title",
      width: 350,
      cellClassName: "fullname-cell",
      headerClassName: "custom-header",
    },
  ];


  const rows = userMyTrips?.map((item, index) => ({
    id: index,
    ID_event: item.ID_event,
    start_date: item.start_date,
    event_status: getTripStatus(item),
    trip_title: item.trip_title,
  }));

  const columnsOfOrganiser = [
    {
      field: "ID_event",
      headerName: "Event ID",
      width: 180,
      renderCell: (params) => (
        <Link
          to={`/event-management/event/${params.value}`}
          style={{ color: "blue" }}
        >
          {params.value}
        </Link>
      ),
      cellClassName: "eventid-cell",
      headerClassName: "custom-header",
    },
    {
      field: "start_date",
      headerName: "Trip date",
      width: 180,
      cellClassName: "fullname-cell",
      headerClassName: "custom-header",
    },
    {
      field: "event_status",
      headerName: "Trip status",
      width: 180,
      cellClassName: "fullname-cell",
      headerClassName: "custom-header",
    },
    {
      field: "trip_title",
      headerName: "Trip title",
      width: 380,
      cellClassName: "fullname-cell",
      headerClassName: "custom-header",
    },
  ];

  const rowsOfOrganiser = myOrganised?.map((item, index) => ({
    id: index,
    ID_event: item.ID_event,
    start_date: item.start_date,
    event_status: getTripStatus(item),
    trip_title: item.trip_title,
  }));

  return (
    <div>
      <div>
        <h6
          style={{
            fontFamily: "Poppins",
            width: "230px",
            marginTop: "40px",
            fontWeight: "bold",
            marginBottom: "40px",
          }}
        >
          Trips
        </h6>
        <DataGridComponent columns={columns} rows={rows} rowCount={rows?.length} />
      </div>
      {userDetails?.user_type === "organiser" ? (
        <div>
          <h6
            style={{
              fontFamily: "Poppins",
              width: "230px",
              marginTop: "20px",
              fontWeight: "bold",
              marginBottom: "40px",
            }}
          >
            Organised trips
          </h6>
          <DataGridComponent
            columns={columnsOfOrganiser}
            rows={rowsOfOrganiser}
            rowCount={rows?.length}
          />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default MyTrips;
